import { useEffect, useState } from 'react';

// The floating chat window (ChatDock) at the bottom right: which conversation it
// shows and whether it is minimised. A tiny store, so the new-message listener
// (useUnreadMessages, outside the router), the chat page's "open in a window"
// button and the window itself share it.
//
// A conversation here: { id, type: 'chat' | 'channel', providerId, name, image,
// receiveId?, members? } — what the window needs to show and send.

let state = { conversation: null, minimized: false };
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener(state));

export const chatDock = {
  get: () => state,
  open: conversation => {
    state = { conversation, minimized: false };
    emit();
  },
  close: () => {
    state = { conversation: null, minimized: false };
    emit();
  },
  setMinimized: minimized => {
    state = { ...state, minimized };
    emit();
  },
  subscribe: listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const useChatDock = () => {
  const [value, setValue] = useState(state);
  useEffect(() => chatDock.subscribe(setValue), []);
  return value;
};

// Screens that already show conversations (the /chat page, the athlete scheda's
// chat): while one is open, a new message toasts instead of opening the window.
let chatScreens = 0;
export const enterChatScreen = () => {
  chatScreens += 1;
  return () => {
    chatScreens = Math.max(0, chatScreens - 1);
  };
};
export const isOnChatScreen = () => chatScreens > 0;

/** The window's conversation for a conversation doc (from a Firestore listener), as seen by `userId`. */
export const dockConversationOf = (doc, type, userId) => {
  const last = doc?.lastMessage || {};
  if (type === 'channel') {
    return { id: doc.id, type, providerId: doc.providerId, name: doc.name, image: doc.image || null, creator: doc.creator };
  }
  const peerId = (doc.members || []).map(String).find(id => id !== String(userId));
  const fromPeer = String(last.senderId) === String(peerId);
  return {
    id: doc.id,
    type,
    providerId: doc.providerId,
    members: doc.members,
    receiveId: peerId ? +peerId : null,
    name: (fromPeer ? last.senderName : last.receiveName) || '',
    image: (fromPeer ? last.senderImage : last.receiveImage) || null,
  };
};
